import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import toast from "react-hot-toast";
import publicRequest from "../../configs/axios";

const initialState = {
  ordersState: [],
  totalOrdersCount: 0,
  status: "idle",
};

export const postOrdersAsync = createAsyncThunk(
  "orders/postOrdersAsync",
  async (payload) => {
    const response = await publicRequest.post("/order", payload);
    return response.data;
  },
);

export const loadOrdersAsync = createAsyncThunk(
  "orders/loadOrdersAsync",
  async (payload) => {
    const { email, page, limit, search, status } = payload || {};
    let url = `/all-orders?page=${page || 0}&limit=${limit || 0}`;
    if (email) {
      url += `&email=${email}`;
    }
    if (search) {
      url += `&search=${search}`;
    }
    if (status && status !== "All") {
      url += `&status=${status}`;
    }
    const response = await publicRequest.get(url);
    return response.data;
  },
);

export const updateOrdersAsync = createAsyncThunk(
  "orders/updateOrdersAsync",
  async (payload) => {
    const response = await publicRequest.put(`/order/${payload.id}`, payload);
    return response.data;
  },
);

export const cancelOrdersAsync = createAsyncThunk(
  "orders/cancelOrdersAsync",
  async (payload) => {
    const response = await publicRequest.delete(`/order/${payload}`);
    return response.data;
  },
);

export const sendToPathaoAsync = createAsyncThunk(
  "orders/sendToPathaoAsync",
  async (orderId) => {
    const response = await publicRequest.put(`/order/${orderId}/pathao`);
    return response.data;
  },
);

export const ordersSlice = createSlice({
  name: "orders",
  initialState,
  reducers: {
    updateOrders: (state, { payload }) => {
      state.ordersState = state.ordersState.map((item) => {
        let items = item;
        if (item._id === payload.id) {
          item.status = payload.status;
          items = { ...item };
        }
        return items;
      });
    },
    editOrders: (state, { payload }) => {
      state.ordersState = state.ordersState.map((order) => {
        if (order._id !== payload.id) return order;
        const { id, ...fields } = payload;
        return { ...order, ...fields };
      });
    },
  },
  extraReducers: (builder) => {
    builder.addCase(postOrdersAsync.pending, (state, action) => {
      toast.loading("Processing... Please Wait!!");
    });
    builder.addCase(postOrdersAsync.fulfilled, (state, { payload }) => {
      toast.dismiss();
      toast.success("Your Order is Successfully post!!!");
    });
    builder.addCase(
      postOrdersAsync.rejected,
      (state, { error: { message } }) => {
        toast.dismiss();
        toast.error(message);
      },
    );
    builder.addCase(loadOrdersAsync.pending, (state, action) => {
      state.status = "Pending";
    });
    builder.addCase(loadOrdersAsync.fulfilled, (state, { payload }) => {
      state.ordersState = payload.data;
      state.totalOrdersCount = payload.count;
      state.status = "Success";
      toast.success("Your Order is loaded!!!");
    });
    builder.addCase(
      loadOrdersAsync.rejected,
      (state, { error: { message } }) => {
        state.status = "Rejected";
        toast.error(message);
      },
    );
    builder.addCase(cancelOrdersAsync.pending, (state, action) => {
      toast.loading("Deleting... Please Wait!!");
    });
    builder.addCase(
      cancelOrdersAsync.fulfilled,
      (state, { payload, meta: { arg } }) => {
        toast.dismiss();
        state.ordersState = state.ordersState.filter(
          (order) => order._id !== arg,
        );
        toast.success("Your Order is canceled..");
      },
    );
    builder.addCase(
      cancelOrdersAsync.rejected,
      (state, { error: { message } }) => {
        toast.dismiss();
        toast.error(message);
      },
    );
    builder.addCase(updateOrdersAsync.pending, (state, action) => {
      toast.loading("updating... Please Wait!!");
    });
    builder.addCase(updateOrdersAsync.fulfilled, (state, { payload, meta }) => {
      toast.dismiss();
      toast.success(
        meta.arg.status
          ? `Order is ${meta.arg.status}`
          : "Order details updated successfully",
      );
    });

    builder.addCase(
      updateOrdersAsync.rejected,
      (state, { error: { message } }) => {
        toast.dismiss();
        toast.error(message);
      },
    );
    builder.addCase(sendToPathaoAsync.pending, (state, action) => {
      toast.loading("Sending to Pathao... Please Wait!!");
    });
    builder.addCase(sendToPathaoAsync.fulfilled, (state, { payload }) => {
      toast.dismiss();
      // Update the order in state with Pathao status
      const orderId = payload?.consignment_id
        ? state.ordersState.find((o) => o.orderId === payload.merchant_order_id)
        : null;
      if (orderId) {
        state.ordersState = state.ordersState.map((item) => {
          if (item._id === orderId._id) {
            return {
              ...item,
              status: "Pathao",
              courier: {
                ...item.courier,
                pathao: {
                  consignment_id: payload.consignment_id,
                  tracking_url: payload.tracking_url,
                },
              },
            };
          }
          return item;
        });
      }
      toast.success("Order sent to Pathao successfully!");
    });
    builder.addCase(
      sendToPathaoAsync.rejected,
      (state, { error: { message } }) => {
        toast.dismiss();
        toast.error(message);
      },
    );
  },
});

export const { updateOrders, editOrders } = ordersSlice.actions;

export default ordersSlice.reducer;
